(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rnl-format-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
  const mount = gallery => {
    if (gallery.dataset.mounted) return;
    gallery.dataset.mounted = 'true';
    const root = gallery.closest('.rl-product-v1');
    if (!root) return;
    const data = JSON.parse(gallery.querySelector('.rnl-gallery-variants').textContent);
    const slides = Array.from(gallery.querySelectorAll('[data-rnl-image]'));
    const buttons = Array.from(gallery.querySelectorAll('[data-rnl-target]'));
    const show = key => {
      if (!slides.some(slide => slide.dataset.rnlImage === key)) key = data.featured;
      if (!slides.some(slide => slide.dataset.rnlImage === key)) key = slides[0]?.dataset.rnlImage;
      slides.forEach(slide => { slide.hidden = slide.dataset.rnlImage !== key; });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rnlTarget === key)));
    };
    const selectVariant = id => {
      const variant = data.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const size = /^\s*(3|4|6|12)\s*ml\s*$/i.exec(variant.size || '');
      const key = size && !/full\s*bottle/i.test(variant.format || '') ? 'format-' + size[1] : variant.image;
      show(key);
    };
    gallery.addEventListener('click', event => {
      const button = event.target.closest('[data-rnl-target]');
      if (button) show(button.dataset.rnlTarget);
    });
    const abort = new AbortController();
    root.addEventListener('change', event => {
      if (!event.target.closest('.product_form')) return;
      requestAnimationFrame(() => {
        const select = root.querySelector('.rl-combined-select') || root.querySelector('.product_form [name="id"]');
        if (select) selectVariant(select.value);
      });
    }, {signal:abort.signal});
    const initial = new URLSearchParams(location.search).get('variant');
    if (initial) selectVariant(initial); else show(data.featured);
    gallery.rnlCleanup = () => abort.abort();
  };
  const init = () => document.querySelectorAll('[data-rnl-gallery]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-rnl-gallery]').forEach(gallery => gallery.rnlCleanup?.()));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rnl-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  document.querySelectorAll('.rnl-nav details[open]').forEach(function(detail) {
    if(!detail.contains(event.target)) detail.removeAttribute('open');
  });
});
document.addEventListener('keydown', function(event) {
  if(event.key === 'Escape') document.querySelectorAll('.rnl-nav details[open]').forEach(function(detail) {detail.removeAttribute('open');detail.querySelector('summary').focus();});
});
  } catch(e) { console.error(e); }
})();

})();
